import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  plansTab: {
    defaultMessage: 'New Plans',
    description: 'Tab label for new plans when migrating to a new plan profile',
    id: 'JN2fPY',
  },
  legacyPlansTab: {
    defaultMessage: 'Current Subscription',
    description: 'Tab label for legacy plans from current plan profile',
    id: 'LU/DUo',
  },
});
